export default "__VITE_ASSET__DSlp4qiL__"